import axios from 'axios'
//import { ID, Response } from '../../../../../_metronic/helpers'
//import { User, UsersQueryResponse } from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL

const GET_REPORT_URL = `${API_URL}/report-list`
const GET_REPORT_DOWNLOAD_URL = `${API_URL}/report-download`
const GET_REPORT_TODAY = `${API_URL}/today`
const GET_REPORT_LIST_BY_PROJECT = `${API_URL}/report-list-by-project`
const GENERATE_REPORT = `${API_URL}/generate-report`
const GET_REPORT_DOWNLOAD_STATUS = `${API_URL}/report-download-status`
const GET_REPORT_DOWNLOAD_LIST = `${API_URL}/report-download-list`
export const getReportList = () => {
    return axios.get(GET_REPORT_URL).then((d) => d.data)
}

export const downloadCSv = (query) => {
    return axios.get(`${GET_REPORT_DOWNLOAD_URL}/${query}`).then((d) => d.data)
}

export const downloadReport = (query) => {
    return axios.get(`${GET_REPORT_TODAY}/${query}`).then((d) => d.data)
}

export const getReportListByProject = () => {
    return axios.get(GET_REPORT_LIST_BY_PROJECT).then((d) => d.data.data)
}

export const generateReport = (data) => {
    return axios.post(GENERATE_REPORT, data).then((d) => d.data)
}

export const getReportDownloadStatus = (data) => {
    return axios.get(GET_REPORT_DOWNLOAD_STATUS, { params: data }).then((d) => d.data)
}

export const getReportDownloadList = () => {
    return axios.get(GET_REPORT_DOWNLOAD_LIST).then((d) => d.data)
}
// const skuUpdate = (query) => {
//     return axios.post(SKU_EDIT, query).then((d) => d.data)
// }

// const skuList = (query) => {
//     return axios.get(`${SKU_LIST}?${query}`).then((d) => d.data)
// }

// const getSkuId = (id) => {
//     return axios.get(`${SKU_BY_ID}/${id}`).then((response) => response.data?.data)
// }